import React, { Component } from "react";

class CFileUpload extends Component {
  constructor(props) {
    super(props);
    this.state = { fileInfo: "", fileKey: 1 };
  }
  addNameToDataURL(dataURL, name) {
    return dataURL.replace(
      ";base64",
      ";name=".concat(encodeURIComponent(name), ";base64")
    );
  }
  processFile(e) {
    const props = this.props;
    let file = e.target.files[0];
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      let fileInfo = {
        name: file.name,
        type: file.type,
        size: Math.round(file.size / 1000) + " kB",
        base64: this.addNameToDataURL(reader.result, file.name),
        file: file,
      };
      this.setState({
        fileKey: this.state.fileKey + 1,
        fileInfo: (
          <div>
            <strong>{fileInfo.name}</strong>
            <span>
              ({fileInfo.type},{fileInfo.size})
            </span>
          </div>
        ),
      });
      props.onChange(fileInfo.base64);
    };
  }
  getsoftLink() {
    const { value } = this.props;
    return value === undefined
      ? false
      : value.indexOf(";base64") > -1
        ? false
        : true;
  }
  componentDidMount() {
    const { value } = this.props;
    if (value === undefined) {
      this.setState({ fileKey: 1, fileInfo: "" });
    }
  }
  getDocumentName() {
    const { value } = this.props;
    return value.substring(value.lastIndexOf('/') + 1);
  }
  render() {
    const { id, required, options, value, disabled } = this.props;
    return (
      <div>
        {value && !disabled && this.getsoftLink() && (
          <p>
            <a
              rel="noopener noreferrer"
              target="_blank"
              href={process.env.REACT_APP_FILE_PATH + value}
              onLoad={() => console.log("- - load - -")}
            >
              {this.getDocumentName()}
            </a>
            <span style={{ float: "right", cursor: "pointer" }}>
              <i
                className="fa fa-times"
                aria-hidden="true"
                onClick={() => {
                  this.props.onChange(undefined);
                  this.setState({ fileInfo: "" });
                }}
              ></i>
            </span>
          </p>
        )}
        {!this.getsoftLink() && !disabled && (
          <input
            id={id}
            type="file"
            required={required}
            accept={options.accept}
            onChange={this.processFile.bind(this)}
          />
        )}
        {!this.getsoftLink() && this.state.fileKey && this.state.fileInfo}
        {disabled && (
          <input type="text" class="form-control" value={value} disabled />
        )}
      </div>
    );
  }
}

export default CFileUpload;
